// Razorpay Configuration
// This configuration now uses dynamic keys from the admin settings

export const RAZORPAY_CONFIG = {
  // Key ID will be fetched dynamically from admin settings
  // This fallback is only used if the API is unavailable
  keyId: 'rzp_test_S6Ro2BBAYyeFhr', // Fallback key - replace with your actual test key
  
  // Currency
  currency: 'INR',
  
  // Company details
  name: 'My Cinemas',
  description: 'Movie Ticket Booking',
  
  // Theme colors (matching your brand)
  theme: {
    color: '#2f3192'
  }
};

// Note: 
// 1. Get your Razorpay credentials from https://dashboard.razorpay.com/
// 2. For test mode, use test keys
// 3. For production, use live keys
// 4. Never expose your key secret in frontend code
// 5. Key secret should only be used on your backend server
